//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import z from "zod";

//* Axios Import
import { formDataApi } from "../../../services/apis/configs/apiClient";


//* Typing imports
import {
  type CreateResourceQuestion,
  fullResourceQuestion,
} from "../../../schemas/common/resource/question/resource-question";



const apiResponse = z.object({
  result: z.boolean(),
  data: z.object({
    recurso: fullResourceQuestion,
    message: z.string(),
  }),
  message: z.union([z.string(), z.number()]),
});


export type StoreResourceQuestionParams = {
  data: CreateResourceQuestion;
  files: File[];
}


async function storeResourceQuestion(params: StoreResourceQuestionParams) {
  try {
    const { data, files } = params;
    const url = "/student_portal/private/recursos/questoes";
    
    const formData = new FormData();
    
    for (const [key, value] of Object.entries(data)) {
      if (key === 'numero_questoes') {
        formData.append('numero_questoes', JSON.stringify(value));
      } else {
        formData.append(key, String(value));
      }
    }
    
    if (files && files.length > 0) {
      files.forEach((file, index) => {
        formData.append(`files[${index}]`, file);
      });
    }
    
    const response = await formDataApi.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    
    return apiResponse.parse(response);
  } catch (err) {
    console.error("Erro ao criar recurso de questão:", err);
    throw err;
  }
}


export function useStoreResourceQuestion() {
  return useMutation({
    mutationFn: storeResourceQuestion,
  });
}
